import React, { useState } from 'react';
import StaticModal from 'shared/common/modal/staticModal';
import './Redeem.css';

function RedeemModal() {
  const [showModal, setShowModal] = useState('');
  return (
    <div>
      {' '}
      <StaticModal
        show={false}
        // handleClose={onKYCPopupClose}
        // title=''
        // onClose={() => {
        //   hideModal()
        // }}

        // size='lg'

        center
      >
        <div>
          <div className='RedeemMainDiv'>
            <p className='text-1 '>
              {' '}
              "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet,
              consectetur, adipisci velit..." "There is no one who loves pain
              itself, who seeks after it and wants to have it, simply because it
              is pain..."
            </p>
            <br />
            <br />
            <button className='btn btn-primary btn-lg'>Redeem</button>
          </div>
        </div>
      </StaticModal>
    </div>
  );
}

export default RedeemModal;
